<template>
  <div>
    <!-- Tìm kiếm -->
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
            tin cung cầu</span></h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Tên sản phẩm:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input placeholder="Nhập tên sản phẩm" v-model="search.cTenSanPham" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Loại tin:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-select placeholder="Tất cả" v-model="search.nNewType">
                  <el-option label="Tất cả" value="-1" selected></el-option>
                  <el-option label="Cung" value="1" selected></el-option>
                  <el-option label="Cầu" value="2" selected></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Trạng thái:</label>
            <el-row :gutter="10">
              <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                <el-select placeholder="Chọn trạng thái" v-model="search.Status">
                  <el-option label="Tất cả" value="5"></el-option>
                  <el-option label="Bình thường" value="1"></el-option>
                  <el-option label="Đã xóa" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                    class="fa fa-search"></i></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>

    </div>


    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div class="body-function w-100">
          <div class="d-flex justify-content-between">
            <el-button type="primary" outline native-type="submit" plain @click="handleOpenAdd">
              <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
              <span class="btn-inner--text">&nbsp;Thêm tin cung cầu</span>
            </el-button>
            <el-button title="Đồng bộ" type="warning" @click="" plain v-loading.fullscreen.lock="isLoading"><i
                class="el-icon-refresh" /></el-button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="col-md-12 tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" height="100%"
            fit stripe highlight-current-row>
            <el-table-column prop="n_ma_cung_cau" label="Mã" width="120"></el-table-column>
            <el-table-column prop="c_ten_san_pham" label="Tên sản phẩm" min-width="150">

            </el-table-column>
            <el-table-column prop="" label="Chi tiết" align="center" width="150">
              <template #default="scope">
                <el-button type="primary" @click="handleOpenDetail(scope.row)">Chi tiết</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="n_loai_cung_cau" label="Loại" width="80" align="center">
              <template #default="scope">
                <el-tag type="primary" v-if="scope.row.n_loai_cung_cau == 1" :size="size">Cung</el-tag>
                <el-tag type="warning" v-if="scope.row.n_loai_cung_cau == 2" :size="size">Cầu</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="d_ngay_tao" label="Ngày tạo" width="120">
              <template #default="scope">
                <span v-if="scope.row.d_ngay_tao">{{
                  momentDate(scope.row.d_ngay_tao)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="n_tinh_trang" label="Trạng thái" width="120" align="center">
              <template #default="scope">
                <el-tag type="success" v-if="scope.row.n_tinh_trang == 1" :size="size">Hoạt Động</el-tag>
                <el-tag type="danger" v-if="scope.row.n_tinh_trang == 0" :size="size">Đã xóa</el-tag>
              </template>
            </el-table-column>
            <!-- Button hành động -->
            <el-table-column width="160" align="center">
              <template #default="scope">
                <el-button type="primary" plain @click="handleOpenEdit(scope.$index, scope.row)"
                  :disabled="scope.row.n_tinh_trang == 0">
                  <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                </el-button>

                <el-button type="danger" plain @click="handleDelete(scope.$index, scope.row)"
                  :disabled="scope.row.n_tinh_trang == 0" v-loading.fullscreen.lock="isLoading">
                  <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="" @current-change="" :current-page.sync="tableData.pageNum"
          :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
        </el-pagination>
      </div>
    </div>

    <el-dialog v-model="centerDialogVisible" :show-close="false" class="p-0  d-block h-auto mw-850px w-100 "
      dataBackDrop="static">
      <template #header="{ close, titleId, titleClass }">
        <div class="d-flex justify-content-between px-4 pt-4">
          <h2 slot="header" class="modal-title" v-if="!operation">
            Thêm tin cung cầu
          </h2>
          <h2 slot="header" class="modal-title" v-if="operation">
            Cập nhật tin cung cầu
          </h2>
          <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal"
            @click="centerDialogVisible = false">
            <span class="svg-icon svg-icon-1">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
      </template>
      <div class="modal-body mh-600px overflow-scroll">
        <el-form :model="validateForm" :rules="rules" ref="validateFormRef" label-width="150px" class="demo-ruleForm">
          <div class="row">
            <div class="col-sm">
              <el-form-item label="Loại" prop="SupplyType">
                <el-select placeholder="Chọn danh mục" v-model="validateForm.SupplyType" style="width: 30%;">
                  <el-option label="Cung" :value="1"></el-option>
                  <el-option label="Cầu" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="validateForm.SupplyType" label="Tên sản phẩm" prop="ProductName">
                <el-select multiple v-if="validateForm.SupplyType == '1'" placeholder="Chọn sản phẩm"
                  v-model="validateForm.ProductName" style="width: 30%;">
                  <el-option v-for="item in productList" :key="item.nMaSanPham" :label="item.cTenSanPham"
                    :value="item.cTenSanPham"></el-option>
                </el-select>
                <el-input v-if="validateForm.SupplyType == '2'" v-model="validateForm.ProductName"
                  autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="Chi tiết" prop="Article">
                <div class="w-100">
                  <QuillEditor class="w-100 d-flex flex-column" ref="quillEditor" @text-change="onTextChange"
                    :options="quillOptions" />
                </div>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>

      <template #footer>
        <div class="modal-footer">
          <div class="btn-group">
            <el-button v-if="!operation" type="primary" @click="handleAdd"
              v-loading.fullscreen.lock="isLoading">Thêm</el-button>
            <el-button v-if="operation" type="primary" @click="handleEdit"
              v-loading.fullscreen.lock="isLoading">Lưu</el-button>
            <el-button outline type="danger" @click="centerDialogVisible = false">Thoát</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
    <el-dialog v-model="detailModal" :show-close="false" class="modalTemp article p-0" dataBackDrop="static">
      <template #header="{ close, titleId, titleClass }">
        <div class="d-flex justify-content-between px-4 pt-4">
          <h2 slot="header" class="modal-title">{{ selected.c_ten_san_pham }}</h2>
          <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal"
            @click="centerDialogVisible = false">
            <span class="svg-icon svg-icon-1">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
      </template>
      <div class="modal-body mh-600px overflow-scroll">
        <div v-html="selected.c_chi_tiet"></div>
      </div>
      <template #footer>
        <div class="modal-footer">
          <div class="btn-group">
            <el-button outline type="danger" @click="detailModal = false, selected = {}">Thoát</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import { ElMessage } from "element-plus";
import { convertToMoney } from "@/utils/stringUtils.ts";
import ImageResize from "quill-image-resize";
import { QuillEditor, Quill } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { useStore } from "vuex";
import { Supply } from "@/store/enums/StoreEnums";
Quill.register("modules/imageResize", ImageResize);

export default {
  components: {
    QuillEditor
  },
  data() {
    return {
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ 'color': [] }, { 'background': [] }],
        [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
        [{ indent: "-1" }, { indent: "+1" }],
        ["image", "link"], ["clean"]
      ],
      editorSettings: {
        modules: {
          imageResize: {}
        }
      },
      quillOptions: {
        theme: 'snow',
        modules: {
          imageResize: {},
          toolbar: {
            container: [
              [{ header: [false, 1, 2, 3, 4, 5, 6] }],
              ["bold", "italic", "underline"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ 'color': [] }, { 'background': [] }],
              [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
              [{ indent: "-1" }, { indent: "+1" }],
              ["image", "link"], ["clean"],
            ],
            handlers: {
              image: this.customImageHandler
            }
          }
        }
      },
      size: "",
      tableData: {
        content: [
        ]
      },
      search: {
        cTenSanPham: '',
        Status: "5",
        nNewType: "-1",
      },
      isSearchLoading: false,
      isLoading: false,
      fileList: [],
      selectedItem: null,
      detailDialog: false,
      centerDialogVisible: true,
      operation: false,
      validateForm: {
        SupplyType: "",
        ProductName: "",
        Article: "",
      },
      rules: {
        SupplyType: [
          { required: true, message: "Bạn chưa chọn loại cung cầu", trigger: "blur", },
        ],
        ProductName: [
          { required: true, message: "Bạn chưa nhập tên sản phẩm", trigger: "blur" },
        ],
      },
      productList: [],
      fit: "cover",
      pageRequest: {
        columnFilters: {},
        pageSize: 30,
        pageNum: 1
      },
      selected: {},
      detailModal: false,
      store: useStore(),
      baseUrl:baseUrl,
    };
  },
  methods: {
    onTextChange(val) {
      this.validateForm.Article = this.$refs.quillEditor.getHTML()
    },
    handleOpenDetail(val) {
      this.selected = val
      this.detailModal = true
    },
    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData();
      formData.append("image", file);
      this.store.dispatch(Supply.SupplyImageAdded,formData).then(res => {
        const url = this.renderImg(res.msg); // Get url from response
        Editor.insertEmbed(cursorLocation, "image", url);
        resetUploader();
      })
        .catch(err => {
          console.log(err);
        });
    },
    handleImageRemoved: function (file, Editor, cursorLocation, resetUploader) {
      this.store.dispatch(Supply.SupplyImageRemoved,file.replace(baseUrl,"")).then(res => {
      })
    },
    renderImg(img) {
      return 'img/supply/' + img
    },
    convertToMoney(val) {
      return convertToMoney(val) + "đ";
    },
    showDetail(row) {
      this.selectedItem = row.odooDefaultCode
      this.detailDialog = true
    },
    hideDialog() {
      this.detailDialog = false
    },

    handleOpenAdd() {
      this.centerDialogVisible = true;
      this.operation = false;
      this.validateForm = {
        SupplyType: "",
        ProductName: "",
        Article: "",
      },
        this.fileList = []
      this.$refs.quillEditor.setHTML("")
    },
    handleAdd() {
      this.$refs.validateFormRef.validate((valid) => {
        if (valid) {
          let pageRequest = {
            columnFilters: {
              cTenSanPham: { value: this.validateForm.ProductName },
              nNewType: { value: this.validateForm.SupplyType },
              detail: { value: this.validateForm.Article },
            }
          }
          /*   this.$api.supply.insertSupplyNew(pageRequest).then(res => {
              if (res.code == 200) {
                this.centerDialogVisible = false;
                ElMessage({ message: "Đăng tin cung cầu thành công", type: "success" })
                this.handleFindPage()
              }
              else {
                ElMessage({ message: "Đăng tin cung cầu không thành công" + res.msg, type: "error" })
              }
            }) */
        }
      })
    },
    handleClose() {
      this.centerDialogVisible = false;
    },
    handleOpenEdit(index, item) {
      this.centerDialogVisible = true
      this.operation = true
      let data = Object.assign({}, item);
      if (data.n_loai_cung_cau == 1) {
        data.c_ten_san_pham = data.c_ten_san_pham.split(',')
      }
      this.validateForm = {
        SupplyType: data.n_loai_cung_cau,
        ProductName: data.c_ten_san_pham,
        Article: data.c_chi_tiet,
        newID: data.n_ma_cung_cau,
      }
      this.$refs.quillEditor.setHTML(data.c_chi_tiet)
    },
    handleEdit() {
      this.$refs.validateFormRef.validate((valid) => {
        if (valid) {
          let pageRequest = {
            columnFilters: {
              cTenSanPham: { value: this.validateForm.ProductName },
              nNewType: { value: this.validateForm.SupplyType },
              detail: { value: this.validateForm.Article },
              newID: { value: this.validateForm.newID }
            }
          }
          this.store.dispatch(Supply.updateSupplyNew, pageRequest).then(res => {
            if (res.code == 200) {
              this.centerDialogVisible = false;
              ElMessage({ message: "Sửa tin cung cầu thành công", type: "success" })
              this.handleFindPage()
            }
            else {
              ElMessage({ message: "Sửa tin cung cầu không thành công" + res.msg, type: "error" })
            }
          })
        }
      })
    },
    handleDelete(index, item) {
      this.$confirm("Bạn có muốn xóa tin cung cầu này không?", "Xác nhận", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          this.isLoading = true
          let pageRequest = {
            columnFilters: {
              newID: { value: item.n_ma_cung_cau }
            }
          }
          /* this.$api.supply.deleteSupplyNew(pageRequest) */
          this.isLoading = false
          ElMessage({
            message: `Xóa thành công`,
            type: "success",
          });
          this.handleFindPage()
        })
        .catch(() => { });
    },
    handleFindPage() {
      this.isSearchLoading = true

      this.pageRequest.columnFilters = {
        cTenSanPham: { value: this.search.cTenSanPham },
        nNewType: { value: this.search.nNewType },
        Status: { value: this.search.Status },
      };
      this.store.dispatch(Supply.findPageSupply, this.pageRequest).then((res) => {
        this.isSearchLoading = false
        if (res.code == 200 && res.data)
          this.tableData = res.data;
        else
          this.tableData = []
      });
    },
    handleChangePageNum(val) {
      this.pageRequest.pageNum = val
      this.handleFindPage()
    },
    handleChangePageSize(val) {
      this.pageRequest.pageSize = val
      this.handleFindPage()
    },
    update: function update() {
      this.$emit('input', this.editor.getText() ? this.editor.root.innerHTML : '');
    },
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    }
  },
  mounted() {
    this.handleFindPage()
    this.centerDialogVisible = false

  },
};
</script>
<style lang="css">
.ql-align-right {
  text-align: right;
}

.ql-align-center {
  text-align: center;
}

.ql-align-left {
  text-align: left;
}

.ql-align-justify {
  text-align: justify;
}
</style>
<style lang="scss" scoped>
.test::v-deep {
  div {
    p {
      img {
        max-width: 80%;
        max-height: 500px;
      }
    }
  }
}

.tbl {
  height: calc(100vh - 255px);
}

.box-card {
  margin: 10px;
}

.supply-card {
  padding: 5px;
  border: 1px solid #dee2e6;
  background-color: #f8f9fa;
  align-items: center;
  cursor: pointer;
}

.supply-name {
  font-size: 13px;
  font-weight: 500;
  margin-left: 5px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.supply-text {
  font-size: 13px;
  margin-left: 5px;
}
</style>
<style lang="scss">
.article {
  .modal-dialog {
    max-width: 90%;
  }
}
</style>